import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {DomainDpApproval, DomainDpStatus} from '../../../shared/domain/domain-dp-approval.model';
import {DpStatsService} from '../../dp-stats.service';
import {SnackBarService} from '../../../shared/services/snackbar.service';
import {GlobalSpinnerService} from '../../../shared/components/loader-service/global-spinner.service';
@Component({
  selector: 'cm-site-dp-reject-dialog',
  template: `
    <h1 mat-dialog-title>
      <i class="fas fa-exclamation-triangle mr-3"></i>
      Site Rejection
    </h1>
    <div mat-dialog-content>
      <mat-list class="mat-dialog-data-list">
        <h3 mat-subheader>You are about to REJECT this/these site(s):</h3>
        <strong></strong>
        <mat-list-item>
          <div class="d-flex flex-column">
            <strong *ngFor="let d of domains">{{d.id.url}}</strong>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end">
      <button mat-button color="primary" mat-dialog-close cdkFocusInitial>Cancel</button>
	    <button mat-button color="warn" (click)="reject()">Reject site(s)</button>
    </div>
  `,
  host: {'class': 'mat-dialog-warn'}
})
export class DpSiteApprovalRejectDialogComponent {
  domains: DomainDpApproval[];
  reason: string;

  constructor(public dialogRef: MatDialogRef<DpSiteApprovalRejectDialogComponent>,
              private service: DpStatsService,
              private sbs: SnackBarService,
              private gss: GlobalSpinnerService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.domains = data.domains;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  reject() {
    this.gss.showLoader();
    this.domains.forEach(d => d.status = DomainDpStatus.REJECTED);
    this.service.siteApprovalUpdate(this.domains).subscribe(next => {
        this.gss.hideLoader();
        this.sbs.success('Site(s) has been rejected successfully');
        this.dialogRef.close(true);
      },
      () => {
        this.gss.hideLoader();
        this.sbs.error('Error occurred during site rejection');
      });
  }

}
